import DatePicker from '../components_v/v-date-range'
import { defaultFun } from '../utils'
import { DATE_RANGE } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name: DATE_RANGE,
    mixins: [ commonMixins ],
    render(h) {
        const {
                         // eslint-disable-next-line 
            slots,scopedSlots,
             key,
             'click:clear': clickClear,
             input = defaultFun,
             change = defaultFun,
             inputTwo = defaultFun,
             ...params 
            } = this.field
            params.locale = params.locale || "zh-cn"
            if (params.attach === undefined) {
                params.attach = true
            }
            if (params._type) {
                params.type = params._type
            }
        return h(DatePicker, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            props: {
                ...params,
                value: this.my_value
            },
            on: {
                input:(data) => {
                    const start_key = params.start_key
                    const end_key = params.end_key
                    this.my_value[start_key] = data[0]
                    this.my_value[end_key] = data[1]
                  this.$nextTick(() => {
                    if (data[0] && data[1]) {
                        inputTwo(data)
                    }
                    input(data)
                  })
                },
                change: (data) => {
                    change(data)
                },
                'click:clear': () => {
                    if (clickClear) {
                        clickClear()
                    }
                }
                // popChange: (val) => {
                //     popChange && popChange(val)
                // }
            }
        })
    }
}